


















































































import { isRoot } from "@/plugins/roles";
import { getCurrentUserId } from "@/plugins/roles";
import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { Disk as IDisk } from "@/api-v2/files/models";
import CFileManagerItem from "@/components/fileManager/CFileManagerItem.vue";
import CFileManagerMenuItem from "@/components/fileManager/CFileManagerMenuItem.vue";
import FileUploadItem from "@/components/fileManager/fileUploadItem.vue";
import { DiskEdit as IDiskEdit } from "@/api-v2/files/models";
import Modal from "@/components/form/Modal.vue";
import CFileManagerAccess from "@/components/fileManager/CFileManagerAccess.vue";

@Component({
  components: {
    CFileManagerAccess,
    Modal,
    FileUploadItem,
    CFileManagerMenuItem,
    CFileManagerItem,
    CSingleSelect,
    CustomButton
  }
})
export default class CFileManager extends Vue {
  @Ref() fileInput: any;
  @Prop({ default: false }) isLoading?: boolean;
  @Prop() id!: string;
  @Prop() currentDisk?: IDisk;
  selectedFileToUpload: Array<File> = [];
  folderName: string = "";
  formDiskEdit: IDiskEdit = {
    ownerId: this.currentUserId,
    title: "",
    spaceLimit: 0
  };

  get root() {
    return isRoot();
  }

  get currentUserId() {
    return getCurrentUserId();
  }

  get isUserCanEditDiskPermission() {
    if (!this.currentDisk) return false;

    return this.currentDisk.owner.id === this.currentUserId || this.root;
  }

  addWritePermissionForUser(userId: string) {
    this.$emit("addWritePermissionForUser", userId);
  }

  closeDiskAccessForUser(userId: string) {
    this.$emit("closeDiskAccessForUser", userId);
  }

  uploadFile() {
    this.$emit("uploadFile", this.selectedFileToUpload);
    this.selectedFileToUpload = [];
  }

  createFolder() {
    this.$store.dispatch(`${this.id}/CREATE_FOLDER`, this.folderName);
    this.folderName = "";
  }
}
